import { API_ENDPOINT } from './constant';

export const API = {
  UsersEndpoint: `${API_ENDPOINT}/users`,
  UsersVerifyEndpoint: `${API_ENDPOINT}/users/verificate`,
  UsersSearchEndpoint: `${API_ENDPOINT}/users/search`,
  UsersTokenEndpoint: `${API_ENDPOINT}/users/token`,
  NotificationEndpoint: `${API_ENDPOINT}/notifications`,
  DeviceTypeEndpoint: (device_type: string) => `${API_ENDPOINT}/devices/${device_type}`,
  OperationListEndpoint: `${API_ENDPOINT}/operations`,
  DeviceInfoEndpoint: (device_id: string) => `${API_ENDPOINT}/devices/${device_id}`,
  DeviceEndpoint: `${API_ENDPOINT}/devices`,
  DeviceSensorEndpoint: (device_id: string) => `${API_ENDPOINT}/devices/${device_id}/sensor`,
};

